var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPsychologist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.14,
    y: 162.32,
    width: 8.14,
    height: 40.42,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.23,
    y: 162.32,
    width: 8.14,
    height: 40.42,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 308.25,
    y: 178.54,
    width: 8.14,
    height: 40.42,
    transform: "translate(511.07 -113.56) rotate(90)",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 308.25,
    y: 170.3,
    width: 8.14,
    height: 40.42,
    transform: "translate(502.82 -121.81) rotate(90)",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188.77,
    y: 162.32,
    width: 8.14,
    height: 40.42,
    transform: "translate(-44.56 63.59) rotate(-16.82)",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.14,
    y: 107.32,
    width: 8.14,
    height: 40.42,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.69,
    y: 106.55,
    width: 8.14,
    height: 40.42,
    transform: "translate(27.46 -56.67) rotate(10.12)",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.23,
    y: 107.32,
    width: 8.14,
    height: 40.42,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.48,
    y: 107.32,
    width: 8.14,
    height: 40.42,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-10--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.7,
    y: 107.32,
    width: 8.14,
    height: 40.42,
    style: {
      fill: "#6b6b6b"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-11--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.92,
    y: 107.32,
    width: 8.14,
    height: 40.42,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-12--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 250.14,
    y: 107.32,
    width: 8.14,
    height: 40.42,
    style: {
      fill: "#6b6b6b"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-13--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.36,
    y: 107.32,
    width: 8.14,
    height: 40.42,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-14--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 301.77,
    y: 123.54,
    width: 8.14,
    height: 40.42,
    transform: "translate(449.59 -162.09) rotate(90)",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-15--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.68,185.73A29.11,29.11,0,0,0,425.43,180c-8.05-.69-19.77,9-20,14.25s-3.21,4.37-4.13,7.36,2.75,2.52,2.75,4.59-4.82,4.6-4.36,6.44,5.51,3.68,5.51,4.82-2.76,3.22-.46,5.06,4.6.46,5.52,2.76,3,4.6,3.68,3-1.61-11-.69-17.7,2.76-9.65,9.88-12.41,12.18-4.83,15.17-7.59S439.68,185.73,439.68,185.73Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-16--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.8,227.74c-2.11-.61,1.21-4.53,2.72-8.15s-2.72-5.74-6-7.55,0-5.44-.3-10.27-4-4.74-5.74-7.54,1.51-12.08-10.26-13.29-16.3.61-21.14,3a13.72,13.72,0,0,0-5.52,5.48c-1.11,1.05-2,2.37-1.47,3.64,1.15,2.76,2.3,4.6.69,7.59s-.69,5.74.69,6.89,1.38,4.14-.92,6.44-1.61,4.13.46,5.28,4.37,4.14,2.3,6.9-1.38,6.66,2.76,7.58a22,22,0,0,1,3.88,1l1,4.41c-.29,1.91-.65,3.65.88,4a3.09,3.09,0,0,0,1.88-.35,14.63,14.63,0,0,0,2.15-.61c1.51-.61,2.11,3,3.62,6s6,1.51,8.46-.61a2.22,2.22,0,0,1,1.85-.57,5.73,5.73,0,0,0,3.09,1.18,8.44,8.44,0,0,0,4.72.9c4.53-.6,3.92-2.41,4.53-5.13s3-2.72,6.64-5.74S473.91,228.34,471.8,227.74Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.17,77.85s-50.53-41.27-116.25-23S186.68,129.79,149,168.72c-19.74,20.38-48.9,27.89-72.35,43.58-75,50.17-63.88,163-6.06,205.5,50.06,36.84,112.61,40.69,194,13.52S404.22,387.83,454.69,310,458.42,133.86,396.17,77.85Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.17,77.85s-50.53-41.27-116.25-23S186.68,129.79,149,168.72c-19.74,20.38-48.9,27.89-72.35,43.58-75,50.17-63.88,163-6.06,205.5,50.06,36.84,112.61,40.69,194,13.52S404.22,387.83,454.69,310,458.42,133.86,396.17,77.85Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 45.7,
    y1: 437,
    x2: 481,
    y2: 437,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 437,
    x2: 38.72,
    y2: 437,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.54,
    y: 93,
    width: 85.38,
    height: 138,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.11,
    y: 110.09,
    width: 64.24,
    height: 103.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.62,
    y: 93,
    width: 85.38,
    height: 138,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.19,
    y: 110.09,
    width: 64.24,
    height: 103.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bookshelf--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.14,
    y: 162.32,
    width: 8.14,
    height: 40.42,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.71,
    y: 167.06,
    width: 9.68,
    height: 1.78,
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.71,
    y: 196.51,
    width: 9.68,
    height: 1.78,
    style: {
      fill: "#F68989"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 175.23,
    y: 162.32,
    width: 8.14,
    height: 40.42,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.8,
    y: 167.06,
    width: 9.68,
    height: 1.78,
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.8,
    y: 196.51,
    width: 9.68,
    height: 1.78,
    style: {
      fill: "#F68989"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 308.25,
    y: 178.54,
    width: 8.14,
    height: 40.42,
    transform: "translate(511.07 -113.56) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.05,
    y: 198.2,
    width: 9.68,
    height: 1.78,
    transform: "translate(525.98 -127.8) rotate(90)",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.6,
    y: 198.2,
    width: 9.68,
    height: 1.78,
    transform: "translate(496.53 -98.35) rotate(90)",
    style: {
      fill: "#F68989"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 308.25,
    y: 170.3,
    width: 8.14,
    height: 40.42,
    transform: "translate(502.82 -121.81) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.05,
    y: 189.95,
    width: 9.68,
    height: 1.78,
    transform: "translate(517.73 -136.05) rotate(90)",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.6,
    y: 189.95,
    width: 9.68,
    height: 1.78,
    transform: "translate(488.29 -106.6) rotate(90)",
    style: {
      fill: "#F68989"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 188.77,
    y: 162.32,
    width: 8.14,
    height: 40.42,
    transform: "translate(-44.56 63.59) rotate(-16.82)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.11,
    y: 167.59,
    width: 9.68,
    height: 1.78,
    transform: "translate(-40.66 61.87) rotate(-16.82)",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.62,
    y: 195.78,
    width: 9.68,
    height: 1.78,
    transform: "translate(-48.45 65.53) rotate(-16.82)",
    style: {
      fill: "#F68989"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.19,189.79s-6.33-7.51-5.14-10.47,3,.59,3,.59-5.33-12-.39-12.65,7.31,9.29,7.31,9.29,1.78-10.28,4.94-6.92-.59,12.06-.59,12.06,6.52-5.14,4.94-.79-8.11,9.48-8.11,9.48Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,190s-8.5-6.92-5.14-8.5,5.33,1.78,5.33,1.78-2-12.06,1.78-12.06,3,9.49,3,9.49,2.17-7.51,4.15-4.74-2.77,14.82-2.77,14.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.66 188.01 245.84 188.01 247.32 202.44 259.18 202.44 260.66 188.01",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.12,
    y: 130.74,
    width: 15.41,
    height: 16.72,
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.04,
    y: 116.11,
    width: 7.58,
    height: 16.72,
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.14,
    y: 107.32,
    width: 8.14,
    height: 40.42,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.71,
    y: 112.06,
    width: 9.68,
    height: 1.78,
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.71,
    y: 141.51,
    width: 9.68,
    height: 1.78,
    style: {
      fill: "#F68989"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 329.69,
    y: 106.55,
    width: 8.14,
    height: 40.42,
    transform: "translate(27.46 -56.67) rotate(10.12)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 331.82,
    y: 111.58,
    width: 9.68,
    height: 1.78,
    transform: "translate(25 -57.4) rotate(10.12)",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.64,
    y: 140.57,
    width: 9.68,
    height: 1.78,
    transform: "translate(30.01 -56.04) rotate(10.12)",
    style: {
      fill: "#F68989"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 175.23,
    y: 107.32,
    width: 8.14,
    height: 40.42,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.8,
    y: 112.06,
    width: 9.68,
    height: 1.78,
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.8,
    y: 141.51,
    width: 9.68,
    height: 1.78,
    style: {
      fill: "#F68989"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 225.48,
    y: 107.32,
    width: 8.14,
    height: 40.42,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-9--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.04,
    y: 112.06,
    width: 9.68,
    height: 1.78,
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.04,
    y: 141.51,
    width: 9.68,
    height: 1.78,
    style: {
      fill: "#F68989"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 233.7,
    y: 107.32,
    width: 8.14,
    height: 40.42,
    style: {
      fill: "#6b6b6b"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-10--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.26,
    y: 112.06,
    width: 9.68,
    height: 1.78,
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.26,
    y: 141.51,
    width: 9.68,
    height: 1.78,
    style: {
      fill: "#F68989"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 241.92,
    y: 107.32,
    width: 8.14,
    height: 40.42,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-11--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.48,
    y: 112.06,
    width: 9.68,
    height: 1.78,
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.48,
    y: 141.51,
    width: 9.68,
    height: 1.78,
    style: {
      fill: "#F68989"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 250.14,
    y: 107.32,
    width: 8.14,
    height: 40.42,
    style: {
      fill: "#6b6b6b"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-12--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.7,
    y: 112.06,
    width: 9.68,
    height: 1.78,
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.7,
    y: 141.51,
    width: 9.68,
    height: 1.78,
    style: {
      fill: "#F68989"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 258.36,
    y: 107.32,
    width: 8.14,
    height: 40.42,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-13--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257.92,
    y: 112.06,
    width: 9.68,
    height: 1.78,
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.92,
    y: 141.51,
    width: 9.68,
    height: 1.78,
    style: {
      fill: "#F68989"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 301.77,
    y: 123.54,
    width: 8.14,
    height: 40.42,
    transform: "translate(449.59 -162.09) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-14--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.57,
    y: 143.2,
    width: 9.68,
    height: 1.78,
    transform: "translate(464.5 -176.32) rotate(90)",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.13,
    y: 143.2,
    width: 9.68,
    height: 1.78,
    transform: "translate(435.06 -146.88) rotate(90)",
    style: {
      fill: "#F68989"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.83,92.67V207.18H346V92.67ZM280.77,97v50.67H225V97ZM164.58,97H220.3v50.67H164.58Zm0,105.86V152.18H220.3v50.68Zm60.46,0V152.18h55.73v50.68Zm116.2,0H285.51V152.18h55.73Zm-55.73-55.19V97h55.73v50.67Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190.61,
    y: 368.28,
    width: 16.44,
    height: 68.72,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.76,
    y: 368.28,
    width: 16.44,
    height: 68.72,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.61,
    y: 361.01,
    width: 124.6,
    height: 10.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.25,348.13a75.16,75.16,0,0,0-5-7c-2.5-3-9.5-8.75-9.5-8.75l9,4.75s-1.5-4.25-3-7.75-4-12-4-12,6,10.25,7.5,12,4,5.5,4,5.5.25-9.5,1.5-12.5,6.5-10,6.5-10-1.75,11-1.75,12.25.75,9,.75,9l3-15.75.25,11,2.25-11.75s1.75,9,2.25,11.75a41.82,41.82,0,0,1,.5,6.25l2.25-8.25,5.5-9.5s0,10.75-.25,11.75-.5,7.5-.5,7.5l3.25-3.5-2.5,7.75,3.25.5,1.5,1.25s-6,1.79-8.64,2.52-7.61,3.73-7.61,3.73Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,348.13s-4.25-9.25-8.5-11.5-6.25-3.25-6.25-3.25,6.25.25,9.5,2.5a17.25,17.25,0,0,1,5,5.75,46.19,46.19,0,0,1-1-9.5c0-5.25,1.25-16.5,1.25-16.5s-.25,14,1,18.75a55.08,55.08,0,0,0,3.5,9.25s.5-4.5,1.25-9a127,127,0,0,1,3.5-13l-2,18a51.9,51.9,0,0,0,3.5-7c1.5-3.75,9-8.75,9-8.75s-5.75,7.25-7,11.25-2.5,7.5-2.5,7.5a26.73,26.73,0,0,1,5-5.75c3-2.5,8.5-4,8.5-4s-7.5,5.5-8.25,7.25-2,5-2,5,7-6,13-7.75c0,0-9.25,6.5-11.75,11Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.78,346.15a17.4,17.4,0,0,0-.65,4.49c0,9.16,5.46,9.92,12.19,9.92s12.19-.51,12.19-9.92a17.4,17.4,0,0,0-.65-4.49Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.13,350.64c0,.2,0,.38,0,.58h24.34c0-.2,0-.38,0-.58,0-.41,0-.83-.06-1.26H240.19Q240.13,350,240.13,350.64Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.29,353.53c0-.28.08-.58.11-.89H240.24c0,.31.07.61.12.89Z",
    style: {
      fill: "#F68989"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "451.17 367.81 456.8 436.56 454.83 436.56 444.69 368.38 451.17 367.81",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.92 367.81 414.55 436.56 412.58 436.56 402.44 368.38 408.92 367.81",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.85 367.81 398.21 436.56 400.19 436.56 410.33 368.38 403.85 367.81",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.96 367.81 350.33 436.56 352.3 436.56 362.44 368.38 355.96 367.81",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.49,258.06H470s7.5,2.08,4.17,10.84S452.1,370.2,452.1,370.2H352.88l-6.25-57.53s-1.26-8.34,4.58-9.59,29.6-.42,34.19-2.92,14.92-38.77,14.92-38.77S401.23,257.21,407.49,258.06Z",
    style: {
      fill: "#F68989",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.73,
    y1: 357.1,
    x2: 352.85,
    y2: 357.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.68,185.73A29.11,29.11,0,0,0,425.43,180c-8.05-.69-19.77,9-20,14.25s-3.21,4.37-4.13,7.36,2.75,2.52,2.75,4.59-4.82,4.6-4.36,6.44,5.51,3.68,5.51,4.82-2.76,3.22-.46,5.06,4.6.46,5.52,2.76,3,4.6,3.68,3-1.61-11-.69-17.7,2.76-9.65,9.88-12.41,12.18-4.83,15.17-7.59S439.68,185.73,439.68,185.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-15--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.83,186.62s-6-4.3-10.32-.58-4,8.31-7.17,9.75-7.74,2.29-6,6.3,4.88,10,1.44,11.18-6,4.3-4.88,5.45",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M439.68,185.73A29.11,29.11,0,0,0,425.43,180c-8.05-.69-19.77,9-20,14.25s-3.21,4.37-4.13,7.36,2.75,2.52,2.75,4.59-4.82,4.6-4.36,6.44,5.51,3.68,5.51,4.82-2.76,3.22-.46,5.06,4.6.46,5.52,2.76,3,4.6,3.68,3-1.61-11-.69-17.7,2.76-9.65,9.88-12.41,12.18-4.83,15.17-7.59S439.68,185.73,439.68,185.73Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,190.55s-11.49,5.29-13.1,9.66-.46,12.18-.92,13.33-4.14,3.22-3.68,4.13a15.94,15.94,0,0,0,2.53,2.76s.46,11.95,3.45,12.87,11-1.6,11-1.6l4.83,17.69,19.76-5.51-7.35-16.78s9-11.72,9.88-19.54-6.89-18.39-12.64-19.54-12.87,2.07-12.87,2.07Z",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 415.2,
    cy: 212.04,
    rx: 1.03,
    ry: 2.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.71,205.72s2.53-3,5.28.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.48,303.41s-19.84,4.29-22.91,4.7-6.34-.81-7.16-1-7.36-3.48-8.18-3.48-3.27,2.05-5.93,2.66-6.13-.61-6.75.62,2.25,1.63,3.68,1.84,4.71.2,4.71.2-5.32,3.07-6.14,3.48-6.34-1.23-5.93.61,8.59,2.87,12.07,3.27,12.47-2.65,12.47-2.65,11.86,2.65,17,2.45,12.06-.61,12.06-.61Z",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.87,315.68s-8.18-3.27-6.54-3.27,5.72,1.84,5.72,1.84-3.07-2.86-2-2.86S360,314,360,314s-3.89-2.25-1.64-1.84,7,1.84,7,1.84",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.66,314.59s-14,0-17.1,7.86,22,98.06,22,98.06-8.89,9.91-15.05,12.31-7.18,3.08-4.79,3.76,13.68,1,19.5-.68,13.68-6.16,16.76-7.53-1.37-4.1-3.42-9.23-9.71-36.49-10.05-46.41-3.77-37.28-3.77-37.28,10.95,7.87,31.47,11.63.69-21.55-8.55-27.36S336.66,314.59,336.66,314.59Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,425.29l-4-4.19c-2,2.14-9.25,9.67-14.51,11.72-6.16,2.39-7.18,3.08-4.79,3.76s13.68,1,19.5-.68,13.68-6.16,16.76-7.53c2.89-1.28-.85-3.77-3-8.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.41,435c-1.29.75-1.07,1.15.33,1.55,2.4.69,13.68,1,19.5-.68s13.68-6.16,16.76-7.53c1.41-.63,1.23-1.55.43-2.85-6.81,3.2-21.13,9.82-23.62,10.15C331.78,436.07,322.85,435.18,321.41,435Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.49,241.12l-23.21,6.66s-2.07,8.51-8.27,13.11-14,9-15.86,16.77-1.38,15.17-.92,22.07-5.06,21.37-5.06,21.37S359,313.52,347.28,314s-20.22-1.15-22.06,10.57,6,92.78,6,92.78-11.95,11-17.24,14.26-9.65,5.28-6.66,6.43,17.93-.46,23.44-1.38,15.17-1.38,16.55-4.6-3.45-18.15-3.22-19.53.67-33.72,2.74-45.44a243.74,243.74,0,0,0,2.76-25.74s51.26,14.25,63.9,14.25,20.91-1.84,24.59-23,.69-24.14,5.06-32.64,8.5-19.08,9-32.18S447.49,241.12,447.49,241.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.12,333.4c-7.92-6.41-11.27-10.57-12.64-13.14-.19.54-.31.84-.31.84S359,313.52,347.28,314s-20.22-1.15-22.06,10.57,6,92.78,6,92.78-11.95,11-17.24,14.26-9.65,5.28-6.66,6.43,17.93-.46,23.44-1.38,15.17-1.38,16.55-4.6-3.45-18.15-3.22-19.53.67-33.72,2.74-45.44a243.74,243.74,0,0,0,2.76-25.74s51.26,14.25,63.9,14.25c9.26,0,16.18-1,20.66-9.85C426.06,343.83,415.55,340.22,407.12,333.4Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.42,418.06c-2.75,2.5-12,10.8-16.45,13.53-5.28,3.21-9.65,5.28-6.66,6.43s17.93-.46,23.44-1.38,15.17-1.38,16.55-4.6c.82-1.91-.56-8-1.76-12.88l-11.48,3.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.31,438c3,1.15,17.93-.46,23.44-1.38s15.17-1.38,16.55-4.6a2.39,2.39,0,0,0,.14-.45c-11.29,2.34-30.79,4-40.75,4.76C306.11,437,306.2,437.6,307.31,438Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.28,247.78s-2.07,8.51-8.27,13.11-14,9-15.86,16.77-1.38,15.17-.92,22.07-5.06,21.37-5.06,21.37-4.24-.91-10.27-2.09c1.42,8.92,7.89,34.41,35.39,36.35,9.39-.89,15.7-5.05,18.78-22.76,3.68-21.15.69-24.14,5.06-32.64s8.5-19.08,9-32.18-4.6-26.66-4.6-26.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.21,
    y1: 253.76,
    x2: 448.87,
    y2: 246.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.57,283.17s-1.09-6.93-2.36-5.94.29,7.14.29,7.14a7.85,7.85,0,0,0,2.21.43",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.72,258.82s-1.38-6.67-9.88-5.52-11.49,5.29-13.79,16.55-5.75,29.65-5.75,29.65-29.42-18.39-33.78-21.38-9.89-3.44-12.41-1.61-9.43,8.51-9.43,8.51-3.45-6.9-3.91-4.6,1.15,8.28,4.6,9.66,9.64-3.39,10.33-3.62-4.14,4.83-2.53,5.06,3-1.84,6-3.68a24.57,24.57,0,0,0,5.31-4.66s16.32,15.63,21.37,19.54S422.67,317,425.43,317s6.43-4.37,8.27-8.28,13.1-29,14.71-41.14",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.7,286.46l1-1.86A19.57,19.57,0,0,1,373.6,282a2.56,2.56,0,0,1,.77-2.15",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.27,286.83s-7.47-7.16-8.07-4.88,6.71,8.13,6.71,8.13a2.71,2.71,0,0,0,3-1.48",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.31,287.16s-3.5-9.73-5.05-8,2.39,10.26,2.39,10.26.56,2.07,4.7-.76",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.09,302.05s-15.34,12.85-33.76,14.13-26.45,4.67-27.62,14.83-2.56,38.88-2.56,38.88l49.62.31,11.51-54.53Z",
    style: {
      fill: "#F68989",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.61,316.69s-4.6,6.14-16.11,7.16-20.21,2.56-23,6.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.8,227.74c-2.11-.61,1.21-4.53,2.72-8.15s-2.72-5.74-6-7.55,0-5.44-.3-10.27-4-4.74-5.74-7.54,1.51-12.08-10.26-13.29-16.3.61-21.14,3a13.72,13.72,0,0,0-5.52,5.48c-1.11,1.05-2,2.37-1.47,3.64,1.15,2.76,2.3,4.6.69,7.59s-.69,5.74.69,6.89,1.38,4.14-.92,6.44-1.61,4.13.46,5.28,4.37,4.14,2.3,6.9-1.38,6.66,2.76,7.58a22,22,0,0,1,3.88,1l1,4.41c-.29,1.91-.65,3.65.88,4a3.09,3.09,0,0,0,1.88-.35,14.63,14.63,0,0,0,2.15-.61c1.51-.61,2.11,3,3.62,6s6,1.51,8.46-.61a2.22,2.22,0,0,1,1.85-.57,5.73,5.73,0,0,0,3.09,1.18,8.44,8.44,0,0,0,4.72.9c4.53-.6,3.92-2.41,4.53-5.13s3-2.72,6.64-5.74S473.91,228.34,471.8,227.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-16--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.11,185.18s2.58,1.44,1.44,5.73-3.16,6.31-1.15,7.74,7.16,4.3,6,8-4.87,7.16-1.72,9.46,9.74,3.72,9.46,8.31-2.3,8,.28,9.46,6.6-1.15,7.17,2-1.15,7.45.86,8,5.1-.6,6,1.43a7.66,7.66,0,0,1,.57,4",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.56,181.46s6,1.72,5.73,6.59-2.58,12-.57,13.18,7.45,2.87,6.88,6.6-2.58,6.87-.86,8.31,6.87,4,6.87,6.3-2.86,2.3-.86,5.45,8.32,2.86,8.6,7.16-1.43,6.6-.57,7.46,3.15,3.43,4,3.72.29,4.3.29,4.3",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.16,177.44s8.88,4.88,8.31,10.61-1.43,8.6,0,10,4.58,3.44,4.58,6.31",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.2,211.84s-.57,5.16,1.72,6.3,7.74,6.88,7.74,10-1.72,6.31.29,8.6a56.54,56.54,0,0,0,6.59,5.74",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M471.8,227.74c-2.11-.61,1.21-4.53,2.72-8.15s-2.72-5.74-6-7.55,0-5.44-.3-10.27-4-4.74-5.74-7.54,1.51-12.08-10.26-13.29-16.3.61-21.14,3a13.72,13.72,0,0,0-5.52,5.48c-1.11,1.05-2,2.37-1.47,3.64,1.15,2.76,2.3,4.6.69,7.59s-.69,5.74.69,6.89,1.38,4.14-.92,6.44-1.61,4.13.46,5.28,4.37,4.14,2.3,6.9-1.38,6.66,2.76,7.58a22,22,0,0,1,3.88,1l1,4.41c-.29,1.91-.65,3.65.88,4a3.09,3.09,0,0,0,1.88-.35,14.63,14.63,0,0,0,2.15-.61c1.51-.61,2.11,3,3.62,6s6,1.51,8.46-.61a2.22,2.22,0,0,1,1.85-.57,5.73,5.73,0,0,0,3.09,1.18,8.44,8.44,0,0,0,4.72.9c4.53-.6,3.92-2.41,4.53-5.13s3-2.72,6.64-5.74S473.91,228.34,471.8,227.74Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "54.19 367.81 48.55 436.56 50.52 436.56 60.66 368.38 54.19 367.81",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.44 367.81 90.8 436.56 92.77 436.56 102.91 368.38 96.44 367.81",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.5 367.81 107.14 436.56 105.17 436.56 95.03 368.38 101.5 367.81",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.39 367.81 155.02 436.56 153.05 436.56 142.91 368.38 149.39 367.81",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.86,258.06H35.33s-7.5,2.08-4.17,10.84,22.1,101.3,22.1,101.3h99.21l6.26-57.53s1.25-8.34-4.59-9.59-29.6-.42-34.18-2.92S105,261.39,105,261.39,104.12,257.21,97.86,258.06Z",
    style: {
      fill: "#F68989",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102.63,
    y1: 357.1,
    x2: 152.51,
    y2: 357.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.09,206.61S72,242.1,72.4,245.29a18.55,18.55,0,0,1-5.07,14.46c-4.88,5.26-24.6,1.31-25.91-3.57s1.12-13,1.12-13S35,241.54,37.1,235s13.52-18.21,18.78-22.15S67.14,205.67,71.09,206.61Z",
    style: {
      fill: "#F68989",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.33,214.07s-11.72,20.38-13.5,25.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.19,213.05s-13,26.75-15.29,37.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7,223.24S58.5,238,57.33,243.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.18,251.11s9.44-.24,13.56-2.42,12.59-.49,15.49,8.23,8.48,24.7,10.66,31.24,7.26,12.59,7.26,12.59l-20.1,7.74-11.62,5.09s-9.2-36.8-12.35-46.25S87,252.32,88.18,251.11Z",
    style: {
      fill: "#787878",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.59 375.57 178.34 391.72 180.31 390.78 175.12 376.62 170.59 375.57",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.19,342.9s9.9,23.45,12,25.65,13.63,7.7,15.36,7.94,5.73.2,5.39,1.17-17.6,10.33-20.62,9.09-3.88-3.94-7.1-5.62-7.68-3.94-9.67-8.09,1.32-7.88,1.32-7.88l-9.05-16.07Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.58,376.49a9.9,9.9,0,0,1-1.74-.58c-3.17,3-9.83,5.94-18.14.4A48.18,48.18,0,0,1,169.29,366a7.19,7.19,0,0,0-.71,7c2,4.15,6.45,6.41,9.67,8.09s4.09,4.38,7.1,5.62,20.28-8.12,20.62-9.09S202.3,376.74,200.58,376.49Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.16,298.85S173.65,332,177,338.76l4.84,9.68-18.4,9.21s-20.1-38.26-20.1-43.83,3.75-11.36,6.17-14.26S159.16,298.85,159.16,298.85Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,389.12s-1.21,25.42-.25,28.33,9,12.83,10.42,13.8,5.08,2.66,4.35,3.39-20.33,1.7-22.51-.73-1.21-9.2-3.39-12.1-5.81-2.91-5.81-7.51,4.6-6.54,4.6-6.54l-1.21-18.4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.21,431.25a13,13,0,0,1-1.69-1.68c-2.68,1-5.58,1.65-7.76.95-5.32-1.69-9.44-5.08-10.65-11.86-.75-4.22-3.86-6.75-6.09-8.06a6.34,6.34,0,0,0-1.17,3.7c0,4.6,3.63,4.6,5.81,7.51s1.21,9.68,3.39,12.1,21.79,1.46,22.51.73S165.66,432.22,164.21,431.25Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.57 417.45 137.57 435.37 139.75 435.37 141.2 420.36 137.57 417.45",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.08,313.58s16.46,1.69,16.22,12.83-1,64.16-1,64.16L138.06,393s-4.85-27.36-3.64-38.5,3.15-13.32,3.15-13.32H101.5s3.63-8.23,15.25-16.95S145.08,313.58,145.08,313.58Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.76,256.19a67.91,67.91,0,0,0,1,8.24c.72,3.63,4.6,5.32,5.81,10.65s-.73,7.75-.49,13.32,3.64,13.07,4.12,15.74-2.42,4.84-6.54,7.5-39.95,16-44.79,10.65-.73-12.83-1.69-18.88-5.82-30.51-8-40S54.84,249.28,60,247.2c3.63-1.45,16.52,3.67,16.52,3.67s4.61.48,14.53.48",
    style: {
      fill: "#787878",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.27,221.26v26.85s5.07,4.32,11.46,9.39,11.08,6,12,1.31-3.2-10.33-4.51-11.64-1.13-12.39-1.13-12.39S75.4,220.32,73,218.81,71.27,221.26,71.27,221.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.63,190.27s9.76,2.63,10,9.58S99.25,209.43,98.13,207s-2.63-14.84-2.45-16.53S99.63,190.27,99.63,190.27Z",
    style: {
      fill: "#F68989",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.22,195.16s4.51,10.7,2.54,19.71-5.92,19.15-9,22-6.76,3.57-13.24-1.69c-4.68-3.8-10.42-11.27-11.83-15.21s-.28-11.83,4.79-19.43S98.13,189.52,101.22,195.16Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.26,
    cy: 212.76,
    rx: 1.16,
    ry: 1.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.56,212.94c0,1.09-.52,2-1.16,2s-1.17-.88-1.17-2,.52-2,1.17-2S101.56,211.85,101.56,212.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.77,208.46s-2.69,2.33-2,5.56,2,5.37,1.43,6.45-3,1.07-3,1.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.69,207.39s4.3-2.33,7.17-1.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.31,206.49s1.79-1.61,3.58.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.43,225.48A4.86,4.86,0,0,1,88,222.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.37,214.2s22.93-3,34-8.78,15.23-9.86,14.33-14.51-12-12.36-24.36-12.19a26.59,26.59,0,0,0-24.19,17C50.32,203.81,53.37,214.2,53.37,214.2Z",
    style: {
      fill: "#F68989",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,189.6a66,66,0,0,1-17.59,13.51,65.72,65.72,0,0,1-21.15,6.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.51,206.93a95.66,95.66,0,0,0,17.58-7.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.91,197.25S85.11,190.11,90.2,185",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.31,214.59s-3.66-8.17-7.89-5.07-1.4,12.11,1.13,13.8,6.2-.84,6.2-.84",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,290.82s9.93-1.7,13.56-2.18,13.08,2.91,12.59,4.6-10.65,2.91-14,4.12-10.9-.49-10.9-.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,250.38s-3.39-5.32-11.38-3.87-10.42,9.68-10.17,17.92,9,44.31,12.1,46.49S109.73,300,109.73,300l-1.7-9.2L75.1,292.76,71.47,263",
    style: {
      fill: "#787878",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.32 290.65 99.17 307.29 108.55 311.27 153.53 295.57 134.32 290.65",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.73,304s-2.34-8.44-8.2-8.44-43.34,12.19-56.23,17.34-23.9,8.2-26.48,12.19,2.11,19.21,10.31,21.55,22.73-.7,28.82-4,47.8-32.8,47.8-32.8",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.32,303.14s15,11.76,33.38,13,26.45,4.67,27.62,14.83,2.56,38.88,2.56,38.88l-49.62.31-9.77-48.37Z",
    style: {
      fill: "#F68989",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7,316.69s4.6,6.14,16.12,7.16,20.2,2.56,23,6.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsychologist);
export default __webpack_public_path__ + "static/media/Psychologist.28a5525d35f766125484adf580487b13.svg";
export { ForwardRef as ReactComponent };